import { render, staticRenderFns } from "./IntegrationUrlsCard.vue?vue&type=template&id=77247ff2&"
import script from "./IntegrationUrlsCard.vue?vue&type=script&lang=js&"
export * from "./IntegrationUrlsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports